import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main/Main'

Vue.use(Router)
const _appRoute = '/' + process.env.APP_NAME + '/dashboard'
// console.log('_appRoute', _appRoute)

export default new Router({
  mode: 'history',
  base: _appRoute,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/:order_id',
      name: 'main-with-id',
      component: Main
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js